<script>
  export let open = false;
  export let active = false;
  export let ariaLabel = "Open menu";
  export let tooltip = "";
  export let align = "top";

  let menuElement;

  function closeMenu(event) {
    if (!menuElement?.contains(event.target)) open = false;
  }
</script>

<svelte:window
  on:click={closeMenu}
  on:keydown={(event) => event.key === "Escape" && (open = false)}
/>

<div class="side-nav-flyout-wrapper" bind:this={menuElement}>
  <button
    class="side-nav-flyout-trigger"
    class:active
    class:open
    type="button"
    aria-label={ariaLabel}
    data-tooltip={tooltip}
    aria-expanded={open}
    on:click={() => (open = !open)}
  >
    <slot name="trigger" />
  </button>
  {#if open}
    <div class="side-nav-flyout-menu" class:align-bottom={align === "bottom"}>
      <slot />
    </div>
  {/if}
</div>

<style>
  .side-nav-flyout-wrapper {
    position: relative;
    width: 100%;
  }

  .side-nav-flyout-trigger {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    padding: .5rem;
    border: 1px solid transparent;
    background: transparent;
    color: var(--pax-black);
    text-align: left;
    cursor: pointer;
  }

  .side-nav-flyout-trigger:hover,
  .side-nav-flyout-trigger.active {
    border-radius: .5rem;
    background: var(--pax-smoke);
  }

  .side-nav-flyout-trigger.active {
    border-color: var(--pax-black);
  }

  :global(.app-side-nav:not(.expanded)) .side-nav-flyout-trigger:not(.open):hover::after {
    content: attr(data-tooltip);
    position: absolute;
    left: calc(100% + .75rem);
    top: 50%;
    z-index: var(--z100);
    transform: translateY(-50%);
    border-radius: .25rem;
    padding: .4rem .55rem;
    background: var(--pax-black);
    color: var(--pax-white);
    font-size: .75rem;
    line-height: 1rem;
    white-space: nowrap;
    pointer-events: none;
  }

  :global(.app-side-nav:not(.expanded)) .side-nav-flyout-trigger:not(.open):hover::before {
    content: "";
    position: absolute;
    left: calc(100% + .4rem);
    top: 50%;
    z-index: var(--z100);
    transform: translateY(-50%);
    border: .35rem solid transparent;
    border-right-color: var(--pax-black);
    pointer-events: none;
  }

  :global(.app-side-nav.expanded) .side-nav-flyout-trigger {
    justify-content: flex-start;
  }

  .side-nav-flyout-menu {
    position: absolute;
    z-index: 20;
    top: 0;
    left: calc(100% + .5rem);
    min-width: 14rem;
    overflow: hidden;
    border: 1px solid var(--border-color);
    border-radius: .5rem;
    background: var(--pax-white);
  }

  .side-nav-flyout-menu.align-bottom {
    top: auto;
    bottom: 0;
  }

  .side-nav-flyout-menu :global(.side-nav-flyout-item) {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    align-items: center;
    gap: .75rem;
    padding: .75rem;
    border: 0;
    background: transparent;
    color: var(--pax-black);
    font-size: .875rem;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
  }

  .side-nav-flyout-menu :global(.side-nav-flyout-item:hover),
  .side-nav-flyout-menu :global(.side-nav-flyout-item.active) {
    background: var(--pax-smoke);
  }
</style>
